//#region Sales catalogue API
export interface SalesCatalogueResponse {
    salesCatalogues: ApiSalesCatalogue[];
}

export interface ApiSalesCatalogue {
    code: string;
    currencyCode: string;
    members: SalesCatalogueItem[];
}

export interface SalesCatalogueItem {
    code: string;
    name: string;
    type: MemberType;
    price: number;
    preparationTests: string[];
    tests: SalesCatalogueItem[];
}

export enum MemberType {
    Test,
    Package,
    TestBundle,
}

export interface SalesCatalogue {
    salesCatalogueCode?: string;
    salesCatalogueName?: string;
    isMonograph?: boolean;
}

//#endregion

//#region Sales catalogue Display
export class SalesCatalogDisplayData {
    code: string;
    name: string;
    currencyCode: string;
    filteredMembers: ScTreeModel[];
}

export class ScTreeModel {
    data?: ScNode = new ScNode();
    children?: ScTreeModel[] = [];
    parentCode?: string;
    key?: string;
    expanded?: boolean;
}

class ScNode {
    code: string;
    name: string;
    price: string;
    priceValue: number;
    type: MemberType;
    preparationTests: string[];
}
//#endregion
